import LineChart from '@/components/LineChart/LineChart';

export default LineChart;
